module.exports = __webpack_public_path__ + "3e833dbab641745995a57c154ff695e0.png";